import type { CallEndpointStore } from '@wtfalch/calls/browser';

/**
 * The engine's store for a call that needs no end-to-end keys: it keeps what
 * the engine saves (a guest's credential, say) in this tab's memory only, never
 * in storage, and has no key machine to open.
 */
export function memoryStore(): CallEndpointStore {
  let held: Record<string, unknown> = {};
  return {
    read: () => held,
    save: (value) => {
      held = value;
    },
    open: () => Promise.reject(new Error('Calls do not use end-to-end keys.')),
  };
}
